import { SwitchCardField } from '@app/components/form/SwitchCardField';
import { publishMessages } from '@app/modules/social-export/publish';
import { FormattedMessage, useIntl } from 'react-intl';

/** YouTube "made for kids" toggle; the description warns about the YouTube Kids restrictions. */
export function YoutubeMadeForKidsField() {
  const { $t } = useIntl();

  return (
    <SwitchCardField
      name="madeForKids"
      label={
        <FormattedMessage
          id="socialExport.youtube.madeForKids"
          defaultMessage="Contenido apto para niños"
        />
      }
      description={$t(publishMessages.forKidsDescription)}
    />
  );
}
